module.exports = __webpack_public_path__ + "static/media/21ECLAC15.2918ba9e.jpg";